define('common/module/realtime/Serum.RelationalRealtimeWidget',[
  'jquery',
  'common/module/asset/Serum.Asset.Fragment',
  'common/js/lib/Serum.Pubsub'
], function($, Fragment, Pubsub) {
  'use strict';

  var CONTENT_ENDPOINT = '/serum/api/content/json/';

  function getContent(id, relationLimit, relationContext) {
    var parameters = [];
    parameters.push('v=2');

    if (relationLimit) {
      parameters.push('limit=' + relationLimit);
    }

    if (relationContext) {
      parameters.push('context=' + relationContext);
    }

    if (parameters.length) {
      parameters = '?' + parameters.join('&');
    } else {
      parameters = '';
    }

    return $.ajax(CONTENT_ENDPOINT + id + parameters);
  }

  function RelationalRealtimeWidget($widget, delegate) {

    var paused = false;
    var widgetID = $widget.attr('data-id');
    var defaultPerspective = 'RICH';
    var defaultAlignment = 'AUTO';
    var relationLimit = $widget.attr('data-relation-limit') || 35;
    var relationContext = $widget.attr('data-relation-context') || null;
    var relationSize = $widget.attr('data-relation-size') || 'AUTO';
    var relationCount;
    var widget;

    function setRelationLimit(limit) {
      relationLimit = limit;
    }

    function getRelationLimit() {
      return window.parseInt(relationLimit, 10);
    }

    function getRelationCount() {
      if (!relationCount) {
        getRelations();
      }

      return relationCount;
    }

    function setDefaultPerspective(perspective) {
      defaultPerspective = perspective;
    }

    /* extend these for special insertion behaviour */
    function onBeforeInsert() { }
    function onAfterInsert() { }

    /* returns a list of relation objects */
    function getRelations() {

      var relations = widget.relationElements().map(function() {
        var $item = $(this);
        var id = $item.attr('data-id');
        return {
          id : id,
          perspective : $item.attr('data-perspective') || 'BRIEF'
        };
      }).get();

      relationCount = relations.length;

      return relations;
    }

    /* moves a relation to the specified relation index in the DOM  */
    function moveRelationTo(from, to) {

      if (paused) {
        return;
      }

      var $items = widget.relationElements();
      var $from = $($items.get(from));
      var $to = $($items.get(to));
      var fromClasses = $from.attr('class');
      var toClasses = $to.attr('class');

      $widget.trigger('beforerealtimereorder', $from, $to);

      $to.attr('class', fromClasses);
      $from.attr('class', toClasses);

      $($to).before($from);

      $widget.trigger('realtimereorder', $from, $to);
    }

    /* returns the index of a relation in the DOM, -1 if it does not exist */
    function indexOfRelation(relations, relation) {
      for (var i = 0; i < relations.length; i++) {
        if (relations[i].id === relation.id) {
          return i;
        }
      }
      return -1;
    }

    /* returns true if there is a difference between the specified relations, false otherwise */
    function relationDifference(r1, r2) { // eslint-disable-line no-unused-vars
      return false;

      /** not implemented

      if (r1.perspective == 'AUTO') {
        r1.perspective = 'RICH';
      }
      if (r2.perspective == 'AUTO') {
        r2.perspective = 'RICH';
      }

      return r1.perspective != r2.perspective;
      */
    }

    function relationPerspective(relation) {
      return (relation.perspective === 'AUTO' || !relation.perspective)
        ? defaultPerspective
        : relation.perspective;
    }

    /* returns a template for the wrapper used when inserting new relations */
    function relationTemplate() {
      return '<div class="relation col"></div>';
    }

    /* creates a jQuery object for a new relations to be inserted in the DOM */
    function createRelation(relation) {
      relation.perspective = defaultPerspective; //Makes messages follow perspective of parent
      var $item = $(widget.relationTemplate(relation))
        .attr('data-id', relation.id)
        .attr('data-reference-id', widgetID + '.' + relation.localref)
        .attr('data-perspective', relation.perspective || defaultPerspective)
        .attr('data-size', relation.size || relationSize)
        .attr('data-alignment', relation.alignment || defaultAlignment);
      if (relation.secondary) {
        $item.attr('data-secondary', relation.secondary);
      }
      return $item;
    }

    /* returns the content element of the specified relation */
    function relationContentElement($item) {
      return $item;
    }

    function relationElements() {
      return $widget.find('.relation');
    }

    function relationContainer() {
      return $widget.find('.relations');
    }

    /* render the specified relation object at the specified index */
    function insertRelationAt(relation, i) {

      $widget.trigger('realtimeinsertion', { relation : relation, index : i, context : relationContext });

      if (paused) {
        return;
      }

      var $item = createRelation(relation);

      var $content = widget.relationContentElement($item);
      widget.onBeforeInsert($content);

      var renderID = relation.id;
      if (widget.renderInContext) {
        renderID = widgetID + '.' + relation.localref;
      }

      var perspective = widget.relationPerspective(relation);
      var params = {};
      if (perspective) {
        params.perspective = perspective;
      }
      if (relation.secondary) {
        params.secondary = relation.secondary;
      }
      //Let widget settings override if relation size is AUTO
      if (relation.size === 'AUTO') {
        params.size = relationSize;
      }

      Fragment.render(renderID, $content, params, {
        stripWhitespace : false,
        onUpdate : function() {
          widget.onAfterInsert($content);
          $widget.trigger('afterrealtimeinsertion', $content);
        }
      });

      var $relations = widget.relationElements();
      if (i === 0) {
        $item.prependTo(widget.relationContainer());
        return;
      }

      var $neighborElement = $relations.get(i);
      if ($neighborElement) {
        $item.insertBefore($neighborElement);
      } else if ($relations.last().length) {
        $item.insertAfter($relations.last());
      } else {
        $item.appendTo(widget.relationContainer());
      }
    }

    function removeRelations(offset) {
      var $relations = widget.relationElements();

      $widget.trigger('beforerealtimedeletion', { offset : offset, relations : $relations });
      if (offset === -1) {
        $relations.remove();
      } else {
        $relations.slice(offset).remove();
      }

      $widget.trigger('realtimedeletion');
    }

    /* repain this relational widget with a master list */
    function repaint(content) {
      $widget.trigger('beforerealtimerepaint');

      var master = content.relations;
      var relations = null;

      if (master.length === 0) {
        removeRelations(-1);
        return;
      }

      $.each(master, function(i, relation) {
        relations = getRelations();

        var k = indexOfRelation(relations, relation);

        if (k === -1) {
          insertRelationAt(relation, i);

        } else if (k !== i) {
          moveRelationTo(k, i);
        }

        if (relationDifference(relations[i], relation)) {
          updateRelation(relation);
        }
      });

      if (relations !== null && master.length < relations.length) {
        setTimeout(function() {
          removeRelations(master.length);
        }, 1500);
      }

      $widget.trigger('realtimerepaint', { master : master });
    }

    function updateRelation(relation) { // eslint-disable-line no-unused-vars
      // TODO
    }

    function isPaused() {
      return paused;
    }

    function pause() {
      paused = true;
    }

    function unpause() {
      paused = false;
      synchronize();
    }

    function synchronize() {
      return getContent(widgetID, relationLimit, relationContext).done(repaint);
    }

    function onUpdate(event, data) {
      event.stopPropagation();
      event.stopImmediatePropagation();

      if (data.id !== widgetID) {
        return;
      }

      synchronize();
    }

    $widget.on('realtimeupdate', onUpdate);
    Pubsub.subscribe('REALTIME_RECONNECTION_SUCCESS', function() {
      setTimeout(synchronize, 1000);
    });

    widget = $.extend({
      relationTemplate : relationTemplate,
      relationContentElement : relationContentElement,
      relationElements : relationElements,
      relationContainer : relationContainer,
      relationPerspective : relationPerspective,

      moveRelationTo : moveRelationTo,
      insertRelationAt : insertRelationAt,
      getRelations : getRelations,

      onAfterInsert : onAfterInsert,
      onBeforeInsert : onBeforeInsert,
      removeRelations : removeRelations,

      synchronize : synchronize,

      isPaused : isPaused,
      pause : pause,
      unpause : unpause,

      setDefaultPerspective : setDefaultPerspective,

      getRelationLimit : getRelationLimit,
      setRelationLimit : setRelationLimit,
      getRelationCount : getRelationCount,

      renderInContext : true
    }, delegate);

    $widget.data('widget', widget);

    return widget;
  }

  return RelationalRealtimeWidget;
});

